import { OverviewInterface } from "@/interface/app/ooc";
import { OverviewType } from "@/types/app/ooc/overview.type";

export default class OverView implements OverviewInterface {
  public static MODULE_NAME = "ooc/overview";
  categories: number = 0;
  items: number = 0;
  modifiers: number = 0;

  constructor(data: OverviewType = null) {
    if (data) {
      this.categories = data.categories || 0;
      this.items = data.items || 0;
      this.modifiers = data["modifier_lists"] || 0;
    }
  }

  /**
   * number formatter
   * @return {string}
   */
  public formatNumber(property: string): string {
    return this[property].toLocaleString() || "";
  }
}
